import axios from 'axios';
import dayjs from 'dayjs';

import { getHeaders } from './utils/getHeader';

export type DailyWeather = {
  /** Average daily temperature, °C. */
  temperature: number | null;
  /** Total precipitation, mm. */
  rain: number | null;
};

type WeatherDay = DailyWeather & {
  /** YYYY-MM-DD */
  date: string;
};

const DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Daily average temperature and rain at a complex, keyed by YYYY-MM-DD.
 * The backend gets it from Visual Crossing and caches past days. Empty when
 * the complex has no location.
 */
export const getDailyWeather = async (
  complexId: number,
  startDate: Date,
  endDate: Date
): Promise<Map<string, DailyWeather>> => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/owner/complexes/${complexId}/weather`;

  const response = await axios.get<WeatherDay[]>(url, {
    headers: getHeaders(true),
    params: {
      startDate: dayjs(startDate).format(DATE_FORMAT),
      endDate: dayjs(endDate).format(DATE_FORMAT),
    },
  });

  return new Map(
    response.data.map(({ date, temperature, rain }) => [
      date,
      { temperature, rain },
    ])
  );
};
